/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    // possible options: error, loading, confirm
    uiStatus: 'loading',
    confirmStatus: {
      message: '',
      title: '',
      buttonLabel: '',
      buttonIcon: '',
      buttonIconPosition: '',
      buttonAction: '',
      cancelButtonLabel: '',
      cancelButtonIcon: '',
      cancelButtonPosition: '',
    },
    /* ****
    ** Current options for errors:
    */
    errorStatus: {
      type: '',
      title: '',
      body: '',
      specialContent: {
        textParts: '',
        buttons: [],
      },
      onCloseNavigate: '',
      isMessageHidden: false,
    },
    /* ****
    ** Current options for loaders:
    ** simple, title-body
    */
    loaderStatus: {
      type: 'init',
      title: '',
      message: '',
    },
    processStatus: {
      totalSteps: 0,
      currentStep: 0,
      humanMessage: '',
      apiMessage: '',
      buttons: [],
      image: '',
    },
  },
  reducers: {
    clearConfirmStatus(state) {
      state.uiStatus = '';
      state.confirmStatus.message = '';
      state.confirmStatus.title = '';
      state.confirmStatus.buttonLabel = '';
      state.confirmStatus.buttonIcon = '';
      state.confirmStatus.buttonIconPosition = '';
      state.confirmStatus.buttonAction = '';
      state.confirmStatus.cancelButtonLabel = '';
      state.confirmStatus.cancelButtonIcon = '';
      state.confirmStatus.cancelButtonPosition = '';
    },
    clearLoaderStatus(state) {
      state.uiStatus = '';
      state.loaderStatus.type = '';
      state.loaderStatus.title = '';
      state.loaderStatus.message = '';
    },
    clearErrorStatus(state) {
      state.uiStatus = '';
      state.errorStatus.type = '';
      state.errorStatus.title = '';
      state.errorStatus.body = '';
      state.errorStatus.specialContent = {
        textParts: '',
        buttons: [],
      };
      state.errorStatus.onCloseNavigate = '';
      state.errorStatus.isMessageHidden = false;
    },
    clearProcessStatus(state) {
      state.uiStatus = '';
      state.processStatus.totalSteps = '';
      state.processStatus.currentStep = '';
      state.processStatus.humanMessage = '';
      state.processStatus.apiMessage = '';
      state.processStatus.buttons = [];
      state.processStatus.image = '';
    },
    setConfirmStatus(state, { payload }) {
      state.uiStatus = 'confirm';
      state.confirmStatus.message = payload.message;
      state.confirmStatus.title = payload.title;
      state.confirmStatus.buttonLabel = payload.buttonLabel;
      state.confirmStatus.buttonIcon = payload.buttonIcon;
      state.confirmStatus.buttonIconPosition = payload.uttonIconPosition;
      state.confirmStatus.buttonAction = payload.buttonAction;
      state.confirmStatus.cancelButtonLabel = payload.cancelButtonLabel;
      state.confirmStatus.cancelButtonIcon = payload.cancelButtonIcon;
      state.confirmStatus.cancelButtonPosition = payload.cancelButtonPosition;
    },
    setErrorStatus(state, { payload }) {
      state.uiStatus = 'error';
      state.errorStatus.type = payload.type;
      state.errorStatus.title = payload.title;
      state.errorStatus.body = payload.body;
      state.errorStatus.specialContent = payload?.specialContent ?? null;
      state.errorStatus.onCloseNavigate = payload?.onCloseNavigate ?? '';
      state.errorStatus.isMessageHidden = payload?.isMessageHidden ?? false;
    },
    setLoaderStatus(state, { payload }) {
      state.uiStatus = 'loading';
      state.loaderStatus.type = payload.type;
      state.loaderStatus.title = payload.title;
      state.loaderStatus.message = payload.message;
    },
    setProcessStatus(state, { payload }) {
      state.uiStatus = 'process';
      state.processStatus.totalSteps = payload.totalSteps;
      state.processStatus.currentStep = payload.currentStep;
      state.processStatus.humanMessage = payload.humanMessage;
      state.processStatus.apiMessage = payload.apiMessage;
      state.processStatus.buttons = payload.buttons;
      state.processStatus.image = payload.image;
    },
    setUiStatus(state, { payload }) {
      state.uiStatus = payload.uiStatus;
    },
  },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
/* eslint-enable no-param-reassign */
